import { useEffect, useState } from 'react';
import { fetchData, textWithColor,textWithIcon } from './Helpers';

export default function Stocks() {
  const [fullData, setFullData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);

  function searchEvent(val) {    
    setSearchData(fullData.filter(item => item.field.toLowerCase().includes(val.toLowerCase())));
  }

  useEffect(() => {
    fetchData("Ownership_Stocks").then((res) => {
      setFullData(res);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const grid = document.getElementById('grid');
    const columns = [
      { name: 'FIELD', field: 'field', scalable: true, leftPinned: true, binding: textWithColor },
      { name: '/VIEWS/CONSOLIDATED/BREAKDOWN', field: 'consolidatedBreakdown', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/CONSOLIDATED/CONCENTRATION', field: 'consolidatedConcentration', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/CONSOLIDATED/INVESTOR', field: 'consolidatedInvestor', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/CONSOLIDATED/RECENT-ACTIVITY', field: 'consolidatedRecentActivity', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/CONSOLIDATED/SHAREHOLDERS-HISTORY-REPORT', field: 'consolidatedHistoryReport', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/CONSOLIDATED/SHAREHOLDERS-REPORT', field: 'consolidatedReport', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/CONSOLIDATED/TOP-N-CONCENTRATION', field: 'consolidatedTopConcentration', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/INSIDER/SHAREHOLDERS-REPORT', field: 'insiderReport', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/INSIDER/TRANSACTION-REPORT', field: 'insiderTrasactionReport', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/INVESTOR/HOLDINGS', field: 'insiderHoldings', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/ULTIMATEPARENT/SHAREHOLDERS-REPORT', field: 'ultimateParentReport', scalable: true, binding: textWithIcon }
    ];

    function gridConfigured(e) {
      const core = e.detail.api.getCoreGrid();
      core.setColumnWidths([250, 270, 280, 260, 300, 400, 350, 350, 280, 280, 220, 350], false);
    }

    grid.config = {
      rowHeight: 120,
      headerRowHeight: 60,
      autoHideScrollbar: false,
      columns: columns,
      dataModel: {
        data: searchData.length > 0 ? searchData : fullData
      }
    };
    grid.addEventListener("configured", gridConfigured);

  }, [fullData, searchData]);

  return (
    <div className='main-div'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>

      <div id='loadingMask_div'>
        <h4>Stocks</h4>
        <p>Available fields for Stocks provided in the different Ownership end-points.</p>
        <ef-layout flex style={{ marginTop: '20px' }}>
          <ef-layout>
            <input
              className='search-field'
              type="text"
              placeholder="Type to search..."
              onChange={(e) => searchEvent(e.target.value)}
            />
          </ef-layout>
        </ef-layout>
        <efx-grid id="grid" className="entity-grid"></efx-grid>
      </div>

    </div>
  );
}